import EmptyPage  from '../components/empty_page';
import renderPage from '../components/render_page';
import Tab        from './onboarding_page';


export default {
  path:         '/:businessID/welcome',
  component:    renderPage(EmptyPage),
  name:         'Onboarding',
  onlyTab:      true,
  tabComponent: {
    component: Tab
  }
};
